export default __webpack_public_path__ + "static/media/Saved.e35e3acd.png";